// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"963033d1","513":"6e624199","703":"f31237a7"}[chunkId] + ".chunk.js";
};